
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import DelDialog from "./delete-dialog.vue";

import Dimensions, {
  DimensionRes,
  Dimension
} from "../../../lib/dimension/dimension";
import _ from "lodash-es";
@Component({
  components: { DelDialog }
})
export default class DimensionSelect extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Boolean, default: true }) canAdd!: boolean;
  @Prop({ type: Number, default: 0 }) industryId!: number; // 行业筛选
  @Prop({ type: Number, default: 0 }) positionId!: number; // 岗位筛选

  dimensionList: Dimension[] = []; //所有维度
  dimensionListDiy: Dimension[] = []; //自定义维度
  warnDimension = false;
  showEdit = false;
  showDel = false;
  name = "";
  nameEn = "";
  id = "";
  showText = false;
  text = "";
  deleteDimensionKey = ""; //将确认删除的key
  dt = "";
  get showMe() {
    return this.show;
  }

  @Watch("show")
  onShow(to: boolean, from: boolean) {
    if (to && !from) {
      this.getDimensionList();
    }
  }

  created() {
    //this.getDimensionList();
  }
  getDimensionList() {
    const p = {
      questionPositionIdList: this.positionId === 0 ? [] : [this.positionId],
      questionIndustryIdList: this.industryId === 0 ? [] : [this.industryId],
      ignoreNoQuestionDimension: 0
    };
    Dimensions.getAll(p).then((res: DimensionRes) => {
      this.dimensionList = res.list;
      //自定义维度
      this.dimensionListDiy = this.dimensionList.filter(
        (d: Dimension) => d.isSystemDimension !== 1
      );
    });
  }
  add() {
    this.name = "";
    this.nameEn = "";
    this.id = "";
    this.showEdit = true;

    //
  }
  edit(d: Dimension) {
    if (d.questionCount || d.questionsIsExamUsed === 1) {
      this.showText = true;
      this.text =
        d.questionsIsExamUsed === 1
          ? "该维度下已有题目被其他面试使用，修改名称会同时修改对应面试和关联题目的考察维度"
          : d.questionCount
          ? "该维度下已有题目，修改名称会同时修改对应面试和关联题目的考察维度"
          : "";
    }
    this.name = d.dimensionName;
    this.nameEn = d.dimensionNameEn;
    this.id = d.dimensionKey;
    this.showEdit = true;

    //
  }

  editCancel() {
    this.showText = false;
    this.showEdit = false;
    this.name = "";
    this.nameEn = "";
    this.id = "";
  }
  editOk() {
    Dimensions[this.id ? "update" : "create"]({
      companyId: Auth.companyId,
      dimensionName: this.name,
      dimensionNameEn: this.nameEn,
      dimensionKey: this.id
    }).then((res: any) => {
      if (res) {
        this.getDimensionList();
        this.$emit("update");
        this.showEdit = false;
      }
    });

    //
  }
  //删除弹窗
  toDelete(d: Dimension) {
    this.showDel = true;
    if (d.questionCount) {
      this.dt =
        "该维度已关联题目，删除维度将同时解除其关联（包括相关AI配置），且无法找回，请谨慎操作";
    } else {
      this.dt = "此操作将删除该考察维度，且无法找回，请谨慎操作";
    }
    this.deleteDimensionKey = d.dimensionKey;
  }
  del() {
    Dimensions.delete({
      companyId: Auth.companyId,
      dimensionKey: this.deleteDimensionKey
    }).then((res: any) => {
      this.showDel = false;
      if (res) {
        this.getDimensionList();
        this.$emit("update");
      }
    });
  }
  //关闭
  close() {
    this.$emit("close", false);
  }
}
